import { DEFAULT_LOCALE, SUPPORTED_LOCALES, getLocaleHreflang } from './locales'
import { resolveLocaleFromPath, toLocalePath } from './routing'
import { hasPathTranslation } from './availability'

export interface AlternateLink {
  locale: string
  hreflang: string
  href: string
}

export interface LocaleSeoLinks {
  canonicalUrl: string
  xDefaultUrl: string
  alternates: AlternateLink[]
}

export function buildLocaleSeoLinks(pathname: string, siteUrl: string): LocaleSeoLinks {
  const resolution = resolveLocaleFromPath(pathname)
  const normalizedPath = resolution.pathWithoutLocalePrefix

  const canonicalPath = toLocalePath(normalizedPath, resolution.locale)
  const canonicalUrl = `${siteUrl}${canonicalPath === '/' ? '' : canonicalPath}`

  const xDefaultPath = toLocalePath(normalizedPath, DEFAULT_LOCALE)
  const xDefaultUrl = `${siteUrl}${xDefaultPath === '/' ? '' : xDefaultPath}`

  const alternates = SUPPORTED_LOCALES
    .filter(locale => hasPathTranslation(locale, normalizedPath))
    .map(locale => {
      const localePath = toLocalePath(normalizedPath, locale)
      return {
        locale,
        hreflang: getLocaleHreflang(locale),
        href: `${siteUrl}${localePath === '/' ? '' : localePath}`,
      }
    })

  return {
    canonicalUrl,
    xDefaultUrl,
    alternates,
  }
}
